import type { FormValuesForVariant } from "@/forms/kartleggingssporsmal/formVariants/types/FormValues";
import type { FormVariant } from "./types/FormVariant";

const formDefaultValuesByFormVariant: {
  [K in FormVariant]: FormValuesForVariant<K>;
} = {
  FLERVALG_V1: {
    tilbakeTilJobbenHvorSannsynligFlervalg: "",
    arbeidsgiverHvordanErSamarbeidFlervalg: "",
    naarTilbakeTilJobbenFlervalg: "",
  },
  FLERVALG_V2: {
    mulighetForTilbakeTilJobbenFlervalg: "",
    arbeidsgiverFaarDuOppfolgingFlervalg: "",
    naarTilbakeTilJobbenFlervalg: "",
  },
  FLERVALG_FRITEKST_V1: {
    tilbakeTilJobbenHvorSannsynligFlervalg: "",
    tilbakeTilJobbenLiteSannsynligBegrunnelse: "",
    tilbakeTilJobbenUsikkerBegrunnelse: "",
    arbeidsgiverHvordanErSamarbeidFlervalg: "",
    arbeidsgiverSamarbeidDarligBegrunnelse: "",
    naarTilbakeTilJobbenFlervalg: "",
  },
  FLERVALG_FRITEKST_V2: {
    tilbakeTilJobbenHvorSannsynligFlervalg: "",
    tilbakeTilJobbenLiteSannsynligBegrunnelse: "",
    tilbakeTilJobbenUsikkerBegrunnelse: "",
    arbeidsgiverFaarDuOppfolgingFlervalg: "",
    arbeidsgiverFaarDuOppfolgingNeiBegrunnelse: "",
    naarTilbakeTilJobbenFlervalg: "",
  },
  FLERVALG_FRITEKST_V3: {
    mulighetForTilbakeTilJobbenFlervalg: "",
    mulighetForTilbakeTilJobbenUtfordrendeBegrunnelse: "",
    arbeidsgiverFaarDuOppfolgingFlervalg: "",
    arbeidsgiverFaarDuOppfolgingNeiBegrunnelse: "",
    naarTilbakeTilJobbenFlervalg: "",
  },
};

export function getFormDefaultValuesForFormVariant<T extends FormVariant>(
  formVariant: T,
): FormValuesForVariant<T> {
  return formDefaultValuesByFormVariant[formVariant];
}
